/**
 * Service de surveillance de l'état d'authentification
 */

import { getToken, saveToken } from "./auth-storage";

// Reduced check interval - only check every 5 minutes instead of 1 minute
const CHECK_INTERVAL = 300000; // 5 minutes

// Intervalle de prolongation en millisecondes
const REFRESH_INTERVAL = 3300000; // 55 minutes

class AuthMonitor {
  private checkTimer: ReturnType<typeof setInterval> | null = null;
  private refreshTimer: ReturnType<typeof setInterval> | null = null;

  /**
   * Démarre la surveillance de l'authentification
   */
  start() {
    this.stop(); // S'assurer qu'il n'y a pas déjà un timer en cours

    // Vérifier l'authentification régulièrement (less frequently now)
    this.checkTimer = setInterval(() => {
      this.checkAuthentication();
    }, CHECK_INTERVAL);

    // Prolonger le token avant expiration
    this.refreshTimer = setInterval(() => {
      this.refreshToken();
    }, REFRESH_INTERVAL);

    // Don't do immediate check - let the auth context handle it
  }

  /**
   * Arrête la surveillance
   */
  stop() {
    if (this.checkTimer) {
      clearInterval(this.checkTimer);
      this.checkTimer = null;
    }

    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  }

  /**
   * Vérifie l'état de l'authentification
   * Now only checks token validity locally instead of making API calls
   */
  async checkAuthentication() {
    const token = getToken();
    if (!token) {
      this.stop();
      return;
    }

    // Instead of calling getMe(), just check if token exists
    // The auth context will handle the actual validation
  }

  /**
   * Prolonge la durée de vie du token
   */
  async refreshToken() {
    const token = getToken();
    if (!token) return;

    try {
      saveToken(token); // Prolonger l'expiration du token actuel
    } catch (error) {
      console.error("🔄 Failed to refresh token:", error);
    }
  }
}

// Singleton
export const authMonitor = new AuthMonitor();
export default authMonitor;
